import { PropsWithChildren } from 'react';

import { SuspenseLoader } from 'components/loaders';

import { useGetBestPracticeComplianceStandards } from '../../hooks/useGetBestPracticeComplianceStandards';

type Props = PropsWithChildren<{
  clusterIds?: string[];
}>;

export const ComplianceStandardsLoading = ({ children, clusterIds }: Props) => {
  const { isLoading } = useGetBestPracticeComplianceStandards({ clusterIds });

  if (isLoading) {
    return <SuspenseLoader />;
  }

  return children;
};
